// extracted by mini-css-extract-plugin
module.exports = {"1":"style_1__3kYRb","2":"style_2__2-ddb","3":"style_3__3NoKq","4":"style_4__3nZ8F","5":"style_5__ZoL6k","service-message":"style_service-message__DyQN6","icon":"style_icon__3hgzN"};